var SCROLL_THRESOLDS = [25, 50, 75, 100];

function canPublishAnalytics() {
  return !!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function");
}

/* Customer-account and checkout-adjacent routes render the shopper's own name, address,
   order lines and email as ordinary page text. This listener forwards e.target.innerText
   into Shopify's Web Pixels event stream for EVERY click on the site, where any connected
   custom pixel can read it - so on those routes it was shipping personal data to analytics.
   Element classes/ids/URLs are still reported there; only the human-readable text is held
   back. Everything on marketing, collection and product pages is unchanged. */
function zenIsPrivateRoute() {
  var p = (window.location && window.location.pathname) || "";
  return /(^|\/)(account|orders|challenge)(\/|$)/.test(p) || p.indexOf("/account") !== -1;
}

document.addEventListener("click", function (e) {
  if (!canPublishAnalytics()) return;
  var t = e.target;
  if (!t || !t.classList) return;
  var text = "";
  if (!zenIsPrivateRoute() && t.innerText) {
    text = t.innerText.replace(/\n/g, "").slice(0, 200);
  }
  Shopify.analytics.publish("click", {
    event: "custom_click",
    event_source: "custom_pixel",
    elementClasses: t.classList.value ? t.classList.value : "",
    elementId: t.id ? t.id : "",
    elementText: text,
    elementTarget: t.target ? t.target : "",
    elementUrl: t.href ? t.href : ""
  });
});

const thresholds = SCROLL_THRESOLDS,
  triggeredThresholds = new Set();

function debounce(e, t) {
  let l;
  return function (...r) {
    clearTimeout(l);
    l = setTimeout(() => e.apply(this, r), t);
  };
}

function checkScrollThresholds() {
  if (!canPublishAnalytics()) return;
  var scrolled = window.scrollY || document.documentElement.scrollTop;
  var full = document.documentElement.scrollHeight;
  var view = document.documentElement.clientHeight;
  var scrollable = full - view;

  /* Guard against scrollable === 0 (page content fits the viewport). scrolled/0 is
     Infinity, which is >= every threshold, so a single stray scroll event - a mobile
     overscroll bounce, for instance - used to fire 25/50/75/100% all at once and record
     a page nobody scrolled as fully read. */
  if (scrollable <= 0) return;

  var pct = Math.round((scrolled / scrollable) * 100);
  if (!isFinite(pct)) return;

  thresholds.forEach(function (threshold) {
    if (pct >= threshold && !triggeredThresholds.has(threshold)) {
      Shopify.analytics.publish("scroll_depth", {
        event: "custom_scroll",
        event_source: "custom_pixel",
        scrollThreshold: threshold,
        scrollUnits: "percent",
        scrollDirection: "vertical"
      });
      triggeredThresholds.add(threshold);
    }
  });
}

window.addEventListener("scroll", debounce(checkScrollThresholds, 100), { passive: true });
